import { isFunction, isNullish } from "@client/common/js/helpers/typeHelpers";

/**
 * @deprecated
 */
export function formatQueryParams(params: Record<string, unknown>, ignoreNull: boolean, skipEncode: boolean): string {
	const parameterKeys = Object.keys(params);

	const includedKeys = parameterKeys.filter((param) => {
		const parameterValue = params[param];
		if (isFunction(parameterValue)) {
			return false;
		}

		if (!ignoreNull) {
			return true;
		}

		if (isNullish(parameterValue)) {
			return false;
		}

		if (typeof parameterValue === "string") {
			return parameterValue.length > 0;
		}

		return Boolean(parameterValue);
	});

	const queryParameters = includedKeys.map((key) => {
		const paremeterValue = params[key];
		if (Array.isArray(paremeterValue)) {
			const arrayParameter = [];

			if (skipEncode) {
				for (const element of paremeterValue) {
					arrayParameter.push(element);
				}

				return key + "=" + arrayParameter.join(`&${key}=`);
			}

			for (const arrayParamValue of paremeterValue) {
				arrayParameter.push(encodeURIComponent(arrayParamValue));
			}

			return key + "=" + arrayParameter.join(`&${encodeURIComponent(key)}=`);
		}

		if (paremeterValue !== null) {
			if (skipEncode) {
				return key + "=" + paremeterValue;
			}

			return key + "=" + encodeURIComponent(paremeterValue);
		}
		return key + "=";
	});
	const queryString = queryParameters.join("&");

	return "?" + queryString;
}

/**
 * @deprecated
 */
export function getQueryParams(): Record<string, string | undefined> {
	const queryParams = new Map<string, string | undefined>();
	const queryItems = window.location.search.slice(1).split("&").filter(Boolean);

	for (const item of queryItems) {
		const [key = "", value] = item.split("=");
		queryParams.set(key, value);
	}

	return Object.fromEntries(queryParams);
}

/**
 * @deprecated
 */
export function parseQueryString(data: Record<string, string | number | boolean>): string {
	const queryParameters = Object.entries(data).map(([key, value]) => [key, value].join("="));
	const queryString = queryParameters.join("&");

	return "?" + queryString;
}
